import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

// Français par défaut (public cible : Suisse romande). L'anglais sert de
// filet de sécurité et prépare une future extension. Les fichiers sont dans
// public/locales/<lng>/translation.json (même mécanique que GameTime).
i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "fr",
    supportedLngs: ["fr", "en"],
    load: "languageOnly",
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
      requestOptions: { cache: "no-cache" },
    },
    react: { useSuspense: false },
    interpolation: { escapeValue: false },
    debug: false,
  });

export default i18n;
